<div class="text-base font-bold text-center mx-auto my-10 p-5">Authorization successful. Redirecting...</div>
